<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>C2C订单审批</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <el-tabs :value="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="所有" name="all"></el-tab-pane>
        <el-tab-pane
          v-for="(type, key) in statusTypes"
          :key="key"
          :label="type.text"
          :name="key"
        ></el-tab-pane>
      </el-tabs>
      <div class="page-actions">
        <el-select v-model="coinType" placeholder="请筛选币种">
          <el-option>全部</el-option>
          <el-option
            v-for="item in coinTypeList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-input
          placeholder="请输入商家用户ID"
          clearable
          v-model="merchantUserId"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入用户ID" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="mark" placeholder="请筛选异常账户">
          <el-option>全部</el-option>
          <el-option
            v-for="item in ifMark"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <!-- <div class="page-actions" v-else>
        <el-input placeholder="请输入商家用户ID" clearable v-model="merchantUserId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input placeholder="请输入用户ID" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select v-model="status">
          <el-option  v-for="(type, key) in statusTypes" :key="key" :label="type.text" :value="type.value"></el-option>
        </el-select>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <a :href="downloadLink" target="_blank">导出Excel</a>
      </div> -->
      <audit-list @refresh="getList"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import AuditList from './components/list';
import { mapState, mapMutations, mapActions } from 'vuex';
import { STATUS_TYPE } from './constants.js';
import qs from 'qs';

export default {
  name: 'MerchantAudit',
  data() {
    return {
      userId: '',
      merchantUserId: '',
      mark: null,
      coinType: '',
      statusTypes: STATUS_TYPE,
      ifMark: [
        { value: true, label: '异常账户' },
        { value: false, label: '非异常账户' }
      ]
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('merchantAudit', ['activeTab', 'pagination', 'coinTypeList']),
    downloadLink() {
      const data = {
        startTime: this.startTime,
        endTime: this.endTime,
        status: 1,
        coinType: this.coinType,
        type: 1
      };
      const params = qs.stringify(data);
      return `/la/admin/statistics/withdrawMoney?${params}`;
    }
  },
  methods: {
    ...mapMutations('merchantAudit', ['changeTab']),
    ...mapActions('merchantAudit', ['list', 'getAllList', 'getCoinTypeList']),
    handleTabChange(tab) {
      this.changeTab(tab.name);
      this.getList({
        page: 1
      });
    },
    getList(data = {}) {
      this.list({
        userId: this.userId,
        merchantUserId: this.merchantUserId,
        coinType: this.coinType,
        status: this.activeTab === 'all' ? '' : this.activeTab,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        mark: this.mark
      });
    }
  },
  created() {
    this.getList({
      page: 1
    });
    this.getCoinTypeList();
  }
};
</script>

<style lang="less">
.user-withdrawal-link {
  color: #409eff;
  .cell {
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.user-withdrawal-records-wrap {
  .el-table {
    .cell {
      font-size: 12px;
      text-align: center;
    }
  }
  .user-withdrawal-pager-wrap {
    text-align: right;
    margin: 10px 0px;
  }
}
</style>
